﻿import moment from "moment-timezone";
import "moment/locale/nl-be";

export function isValidDateRange(van, tot) {
  var vanDate = moment(van, "DD.MM.YYYY");
  var totDate = moment(tot, "DD.MM.YYYY");
  return totDate.diff(vanDate, "days") >= 0;
}

export function getNow() {
  return moment();
}

export function isLaterThanToday(date) {
  moment.locale("nl-be");
  return moment(date, "dddd D MMMM YYYY", true).diff(moment(), "days") > 0;
}

export function isEarlierThanToday(date) {
  moment.locale("nl-be");
  return moment(date, "dddd D MMMM YYYY", true).diff(moment(), "days") < 0;
}
export function dateDiffToday(date) {
  moment.locale("nl-be");
  return moment(date, "DD.MM.YYYY", true).diff(moment(), "days");
}

export function toFormat(format, date) {
  return moment(date).format(format);
}

export function isValidDate(dateString) {
  if (dateString.length != 10) {
    return false;
  }
  return moment(dateString, "DD.MM.YYYY", true).isValid();
}

export const dateValidator = (date) =>
  date == null || date == "" ? true : isValidDate(date);
